const buildAccess = (name, type) => ({
  read: `${name} read${type ? ` ${type}` : ''}`,
  update: `${name} update${type ? ` ${type}` : ''}`,
  create: `${name} create${type ? ` ${type}` : ''}`,
  delete: `${name} delete${type ? ` ${type}` : ''}`,
  confirm: `${name} confirm${type ? ` ${type}` : ''}`,
});

export default buildAccess;
